const ja = {
    splash: {
        start: {
            helper: "ボタンを押して開始してください",
            button: "注文を開始"
        },
        banner: {
            title: "{ORGANISATION}へようこそ！",
            content: "このセルフサービスキオスクで入場チケットを簡単にご注文いただけます。"
        }
    },
    catalog: {
        loading: "読み込み中...",
        tabs: {
            ongoing: "開催中",
            all: "すべて"
        },
        items: {
            select: "選択",
            empty: "今後のイベントはありません！"
        }
    },
    cart: {
        title: "予約内容",
        empty: "予約内容にチケットはまだありません！",
        items: {
            tickets: "チケット",
            date: "日付",
            time: "時間"
        },
        total: "合計金額",
        buttons: {
            checkout: "お会計へ",
            cancel: "キャンセル"
        }
    },
    booking: {
        steps: {
            quantity: {
                title: "チケット枚数"
            },
            upsell: {
                title: "追加オプション"
            },
            plot: {
                title: "予約",
                empty: "利用可能な予約枠がありません。",
                now: "今すぐ入場するための予約枠を選択しました。",
                change: "変更"
            }
        },
        buttons: {
            continue: "続ける",
            return: "戻る",
            cancel: "キャンセル"
        }
    },
    checkout: {
        loading: "読み込み中...",
        steps: {
            payment: "決済端末でお支払いを完了してください...",
            acts: {
                payment: "カードまたは現金でお支払いを完了してください...",
                paymentLeft: "残りのお支払い金額: {paymentLeft}",
                cancel: "キャンセル"
            },
            tickets: "お支払いが完了しました。チケットをお取りください...",
            tickets_info: "カード利用控えも印刷しますか？",
            receipt: "レシートをお取りください...",
            receipt_info: "カード利用控えが印刷されました。",
            failures: {
                transaction: {
                    title: "お支払いは完了していません！",
                    description: "もう一度お支払いをお試しください。"
                },
                print: {
                    title: "チケットとレシートを印刷できませんでした！",
                    description: "スタッフにプリンターの確認を依頼してください。その後、チケットとカード利用控えは印刷されます。"
                }
            },
            error: "注文を作成できませんでした！"
        },
        buttons: {
            retry: "再試行",
            cancel: "戻る",
            next: "次のお客様",
            yes: "はい",
            yes_info: "レシートが必要です！",
            no: "いいえ",
            no_info: "レシートは不要です！",
            reprint_tickets: "チケットを再印刷",
            reprint_tickets_countdown: "チケットを再印刷 ({seconds}s)"
        }
    },
    errors: {
        audience_not_found: "対象者が見つかりませんでした。",
        captcha_invalid: "CAPTCHAが無効です。ページを再読み込みして再度ご注文ください。",
        coupon_expired: "このクーポンは期限切れです。",
        coupon_invalid: "入力されたクーポンコードは無効です。",
        coupon_product_mismatch: "このクーポンはこの商品には使用できません。",
        coupon_redemptions_exceeded: "このクーポンはすでに上限まで利用されています。",
        customer_field_invalid: "入力内容に誤りがあります。内容をご確認ください。",
        customer_field_missing: "入力必須項目が不足しています。内容をご確認ください。",
        customer_token_invalid: "顧客トークンが無効です。再度ログインしてください。",
        customer_token_required: "このメールアドレスは既に登録されています。注文前にログインしてください。",
        plot_capacity_insufficient: "選択した予約枠には空きがありません。別の予約枠を選択してください。",
        plot_not_found: "選択した予約枠は利用できなくなりました。",
        product_max_quantity_exceeded: "チケット枚数が上限を超えています。枚数を減らしてください。",
        product_min_quantity_exceeded: "チケット枚数が最小購入数を下回っています。枚数を増やしてください。",
        product_not_found: "選択した商品は利用できなくなりました。",
        rebook_invalid: "予約変更は無効です。",
        rebook_product_mismatch: "指定された商品では予約変更できません。",
        subscription_expired: "サブスクリプションの有効期限が切れています。",
        subscription_inactive: "サブスクリプションは現在無効です。空き枠不足の可能性があります。",
        subscription_invalid: "サブスクリプションが無効です。",
        subscription_not_found: "指定されたサブスクリプションが見つかりません。",
        subscription_product_mismatch: "このサブスクリプションではこの商品を利用できません。",
        subscription_quantity_mismatch: "このサブスクリプションではこの数量を利用できません。",
        subscription_redemptions_exceeded: "サブスクリプションの利用上限を超えています。",
        subscription_used_today: "このサブスクリプションは本日すでに使用されています。",
        upsell_not_allowed: "この追加オプションはこの商品と一緒に購入できません。",
        upsell_not_found: "追加オプションが見つかりません。"
    },
    printer: {
        title: "プリンターエラーが発生しました！",
        reload: "再試行",
        errors: {
            paper_empty: "用紙残量が少なくなっています。",
            cover_open: "カバーが開いています。",
            device_offline: "接続できません。",
            device_malfunction: "一般的なエラーが発生しました。"
        }
    }
};

export default ja;
